import { NodeSelection } from '@tiptap/pm/state';
import type { Editor } from '@tiptap/core';

/**
 * A click on the field's own padding selects the field.
 *
 * A node that holds content is marked draggable only while it is node-selected
 * (`prosemirror-view`, `selectNode`), so without a way to select it a drag inside a field drags the
 * TEXT and leaves the field behind. The content area is left alone - that is where people type.
 */
export const selectFieldOnEdgeClick = (
  wrapper: HTMLElement,
  editor: Editor,
  getPos: () => number | undefined
): (() => void) => {
  const onMouseDown = (event: MouseEvent) => {
    if (event.button !== 0 || !editor.isEditable) return;
    // The wrapper itself, so anything in the content area - which is a child of it - is left alone.
    if (event.target !== wrapper) return;
    const pos = getPos();
    if (pos === undefined) return;
    const { state, dispatch } = editor.view;
    if (pos < 0 || pos >= state.doc.content.size) return;
    dispatch(state.tr.setSelection(NodeSelection.create(state.doc, pos)));
  };
  wrapper.addEventListener('mousedown', onMouseDown);
  return () => wrapper.removeEventListener('mousedown', onMouseDown);
};
